import { ImageBlock } from 'components/general/blocks/imageBlock/ImageBlock';
import { MediaBlock } from 'components/general/blocks/mediaBlock/MediaBlock';
import { DefaultMediaBlockProps } from 'components/general/blocks/switchBlock/SwitchBlock';
import { widont } from 'utils/typography';
import style from './WorkIntroText.module.scss';

export type WorkIntroTextType = {
  html: string;
  client: string;
  title: string;
  hero: DefaultMediaBlockProps;
};
export const WorkIntroText = ({ html, client, title, hero }: WorkIntroTextType): JSX.Element => {
  return (
    <div className={style.container}>
      <div className={style.client} dangerouslySetInnerHTML={{ __html: client }} />
      <div className={style.title}>
        <div className={style.span} dangerouslySetInnerHTML={{ __html: title }} />
      </div>
      <div className={style.hero}>
        <MediaBlock media={hero} layout="responsive" block_type="media" />
      </div>
      <div className={style.text} dangerouslySetInnerHTML={{ __html: widont(html) }}></div>
    </div>
  );
};
